"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuList;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _HorizontalLineSpacer = _interopRequireDefault(require("./HorizontalLineSpacer"));
var _MenuListItem = _interopRequireDefault(require("./MenuListItem"));
var _MenuListItemExtended = _interopRequireDefault(require("./MenuListItemExtended"));
// import { backgroundColors } from '@sart/styles'

// const SPACING = 24

function MenuList(props) {
  var children = props.children,
    color = props.color,
    style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, style]
  }, _react["default"].Children.map(children, function (child, index) {
    var lastOf = index === children.length - 1;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, child, !lastOf && /*#__PURE__*/_react["default"].createElement(_HorizontalLineSpacer["default"], {
      color: color,
      style: styles.line
    }));
  }));
}
MenuList.Item = _MenuListItem["default"];
MenuList.ItemExtended = _MenuListItemExtended["default"];
var styles = _reactNative.StyleSheet.create({
  container: {
    // paddingTop: SPACING / 2,
    // paddingBottom: SPACING / 2
  },
  line: {
    height: 6,
    color: 'red'
  }
});